import React, { createContext, useContext, useState } from 'react';

const MapSyncContext = createContext();

export const MapSyncProvider = ({ children }) => {
  const [mapState, setMapState] = useState({
    center: [51.505, -0.09],  // Valores iniciales
    zoom: 3.55,
  });

  const updateMapState = (newState) => {
    setMapState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const syncMaps = (syncState) => {
    setMapState(syncState);
  };

  return (
    <MapSyncContext.Provider value={{ mapState, updateMapState, syncMaps }}>
      {children}
    </MapSyncContext.Provider>
  );
};

export const useMapSync = () => {
  const context = useContext(MapSyncContext);
  if (!context) {
    throw new Error('useMapSync must be used within a MapSyncProvider');
  }
  return context;
};
